/**
 * A step of the `POST /legal/TSS/ReInitialize` sequence (#613) — mirrors the C# `TssReinitializeResult.Step`
 * wire values exactly (Newtonsoft serialises the enum as the bare name). `Completed` is the only *success*
 * value; every other value only ever appears inside a `RESUME_AT_*` error's `details.step`, naming where the
 * previous attempt stopped.
 */
export enum LegalTssReinitializeStep {
  Preconditions = "Preconditions",
  Retire = "Retire",
  RetireRegistrations = "RetireRegistrations",
  DeregisterClients = "DeregisterClients",
  RevokeSessions = "RevokeSessions",
  Create = "Create",
  Initialize = "Initialize",
  Completed = "Completed"
}

/** German display copy for {@link LegalTssReinitializeStep} — used to name where a resumable attempt stopped. */
export class LegalTssReinitializeStepHelper {
  public static toDisplayString(step: LegalTssReinitializeStep | string | undefined): string {
    switch (step) {
      case LegalTssReinitializeStep.Preconditions:
        return "Vorbedingungen prüfen";
      case LegalTssReinitializeStep.Retire:
        return "Alte TSE zurückziehen";
      case LegalTssReinitializeStep.RetireRegistrations:
        return "Geräteregistrierungen zurückziehen";
      case LegalTssReinitializeStep.DeregisterClients:
        return "Geräte beim Anbieter abmelden";
      case LegalTssReinitializeStep.RevokeSessions:
        return "Kassen-Sitzungen widerrufen";
      case LegalTssReinitializeStep.Create:
        return "Neue TSE erstellen";
      case LegalTssReinitializeStep.Initialize:
        return "TSE initialisieren";
      case LegalTssReinitializeStep.Completed:
        return "Abgeschlossen";
      default:
        return "Unbekannter Schritt";
    }
  }
}
